/**
 * ModuleOptionRow - Radio de un módulo en el paso 2 del wizard "Copiar módulo".
 * Los módulos creados o editados por profesorado muestran su avatar (mismo
 * criterio que las filas de la vista de organización); el nombre acompaña al
 * avatar en texto y se revela al enfocar la fila, porque el tooltip del avatar
 * solo responde al ratón.
 */

import React from 'react';
import InputRadio from '../../../../../atoms/InputRadio/InputRadio';
import CreatedByInfo from '../CreatedByInfo';
import type { CopyModuleOption } from './useCopyModuleDialog';

type ModuleOptionRowProps = {
  authorLabel: string;
  isSelected: boolean;
  module: CopyModuleOption;
  name: string;
  onSelect: (moduleGuid: string) => void;
};

function ModuleOptionRow({ authorLabel, isSelected, module, name, onSelect }: ModuleOptionRowProps): JSX.Element {
  function handleChange(): void {
    onSelect(module.guid);
  }

  const label = (
    <span className="copy-module-dialog__option">
      <span className="copy-module-dialog__option-texts">
        <span className="copy-module-dialog__option-name">{module.name}</span>
      </span>
      {module.shouldShowAuthor && (
        <span className="copy-module-dialog__option-author">
          <span className="sr-only copy-module-dialog__option-author-name">{`${authorLabel} ${module.authorName}`}</span>
          <CreatedByInfo avatar={module.authorAvatar} name={module.authorName} role={module.authorRole} />
        </span>
      )}
    </span>
  );

  return <InputRadio checked={isSelected} label={label} name={name} onChange={handleChange} value={module.guid} variant="check" />;
}

export default ModuleOptionRow;
